/** Freunde werben (MP-E): Text zum Weitergeben, Link zum Laden, Zähler. Der Laden trägt die Werberin beim Anlegen ein. */
import { useState } from "react";
import { Link } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { Button, Notice, Seitenzustand } from "../ui";
import { Card } from "../ui/Layout";
import { api, rufe } from "../api/client";
import { teilen } from "./cockpit-api";
import { kartenLink } from "../seiten/RegalSeite";
import { useT, useTx } from "../i18n";

interface Werben {
  mieternummer: string;
  name: string;
  laden: { name: string; slug: string; telefon: string; adresse: { strasse?: string; plz?: string; ort?: string } };
  geworben: number;
}

export function Werben() {
  const tx = useTx();
  const t = useT();
  const q = useQuery({ queryKey: ["mieter", "werben"], queryFn: () => rufe<Werben>(api.api.mieter.werben.$get()) });
  const [meldung, setMeldung] = useState<string | null>(null);
  return (
    <div className="sc-col" style={{ gap: "var(--space-4)" }}>
      <div className="sc-row">
        <Link to="/mieter/profil" className="rg-btn rg-btn--quiet" aria-label={t("zurueck")}>‹</Link>
        <h1 className="title">{t("profil.werben")}</h1>
      </div>
      <Seitenzustand query={q} lines={4}>
        {(d) => {
          const vorname = d.name.split(" ")[0] || d.name;
          const adresse = [d.laden.adresse.strasse, [d.laden.adresse.plz, d.laden.adresse.ort].filter(Boolean).join(" ")].filter(Boolean).join(", ");
          const text = `Ich verkaufe meine Sachen bei ${d.laden.name}${adresse ? ` (${adresse})` : ""} – ein eigenes Regal mieten geht ganz einfach, kassiert wird im Laden. Sag beim Anmelden, dass ${vorname} (Mieternummer ${d.mieternummer}) dich geschickt hat.`;
          return (
            <>
              <section className="mp-hero">
                <span className="mp-hero__hallo">Deine Werbe-Nummer</span>
                <span className="mp-hero__betrag">{d.mieternummer}</span>
                <span className="mp-hero__heute is-joy">{d.geworben === 0 ? "Noch niemand geworben – das ändert sich." : d.geworben === 1 ? "1 Person hat dich angegeben" : `${d.geworben} Personen haben dich angegeben`}</span>
              </section>
              <Card title={tx("So geht’s")}>
                <ol style={{ margin: 0, paddingLeft: 20 }} className="sc-col">
                  <li>Text weitergeben – per WhatsApp, Nachricht oder einfach erzählen.</li>
                  <li>Deine Bekannte meldet sich im Laden und nennt deine Mieternummer.</li>
                  <li>Der Laden trägt dich als Werberin ein – du siehst es hier. Ob es eine Belohnung gibt, entscheidet der Laden.</li>
                </ol>
              </Card>
              {meldung ? <Notice tone="success">{meldung}</Notice> : null}
              <Card title={tx("Dein Text")}>
                <p style={{ margin: 0 }}>{text}</p>
                <div className="sc-toolbar" style={{ marginTop: "var(--space-3)" }}>
                  <Button variant="primary" icon="sparkles" onClick={() => void teilen({ titel: `Regal mieten bei ${d.laden.name}`, text, url: adresse ? kartenLink(d.laden.adresse, d.laden.name) : undefined }).then((r) => setMeldung(r === "kopiert" ? "Text kopiert – jetzt einfügen und abschicken." : r === "geteilt" ? "Geteilt." : null))}>Weitergeben</Button>
                  {d.laden.telefon ? <a href={`tel:${d.laden.telefon.replace(/\s/g, "")}`} className="rg-btn rg-btn--secondary">Laden anrufen</a> : null}
                </div>
              </Card>
            </>
          );
        }}
      </Seitenzustand>
    </div>
  );
}
